import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { DataDocAge } from '../../classes/doc-age-data.model';
import { DocsService } from '../../services/docs.service';

import Chart, { ChartItem } from 'chart.js/auto';
import { getRelativePosition } from 'chart.js/helpers';

@Component({
  selector: 'molla-statistiche-agente',
  templateUrl: './statistiche-agente.component.html',
  styleUrls: ['./statistiche-agente.component.scss']
})
export class StatisticheAgenteComponent implements OnInit, AfterViewInit {

  @Input() COD_AGE: string;
  loaded = false;
  iOrdAge!: DataDocAge;


  @ViewChild('clienti')
  canvasCli: ElementRef | undefined;
  chartCli: Chart<'bar', (number | ChartItem)[]> | undefined;

  @ViewChild('venduto')
  canvasVen: ElementRef | undefined;
  chartVen: Chart<'pie', (number | ChartItem)[]> | undefined;

  public dataPie: any = {
    labels: [],
    datasets: [{
      data: [],
      label: [],
      hoverOffset: 4,
      //backgroundColor: ['#36A2EB', '#FF6384', '#FFCD56', '#FF9F40', '#4BC0C0', '#C9CBCF']
    }],
    // options: {
    //   responsive: true,
    //   plugins: {
    //     // datalabels: {
    //     //   display: false
    //     // },
    //     datalabels: {
    //       // formatter: function (value, context) {
    //       //   return context.chart.data.labels[context.datalabels];
    //       // }
    //       formatter: function (value, context) {
    //         return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    //       }
    //     },
    //     tooltip: false,
    //     title: {
    //       display: false
    //     }
    //   }
    //},
  };

  public dataBar: any = {
    labels: [],
    datasets: [{
      data: [],
      borderWidth: 1
    }]
    // options: {
    //   responsive: true,
    //   plugins: {
    //     // datalabels: {
    //     //   display: false
    //     // },
    //     datalabels: {
    //       display: true,
    //       formatter: function (value, context) { //questo funzionerebbe
    //         return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    //       }
    //     },
    //     title: {
    //       display: false
    //     },
    //     tooltip: {
    //       callbacks: {
    //         label: function (context) {

    //           console.log('ddd')

    //           let label = context.dataset.label || '';

    //           if (label) {
    //             label += ': ';
    //           }
    //           if (context.parsed.y !== null) {
    //             label += new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(context.parsed.y);
    //           }
    //           return label;
    //         }
    //       }
    //     }
    //   }
    // },
  };



  constructor(private docService: DocsService) { }


  ngOnInit(): void {
    this.loadData().then(() => {
      this.ngAfterViewInit();
    });
  }

  ngAfterViewInit() {
    this.destroyCharts(); // Destroy existing charts

    if (this.canvasVen && this.canvasVen.nativeElement) {
      this.chartVen = new Chart(
        this.canvasVen.nativeElement,
        {
          type: 'pie',
          data: this.dataPie,
          options: {
            animation: {
              animateScale: true,
              animateRotate: false
            },
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    let label = context.dataset.label || '';

                    if (label) {
                      let value = context.dataset.data[context.dataIndex];
                      label += ': ' + value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
                    }
                    return label;
                  }
                }
              }
            }
          }
        }
      );
    }

    if (this.canvasCli && this.canvasCli.nativeElement) {
      this.chartCli = new Chart(
        this.canvasCli.nativeElement,
        {
          type: 'bar',
          data: this.dataBar,
          options: {
            scales: {
              y: {
                beginAtZero: true
              },
              x: {
                beginAtZero: true
              }
            },
            plugins: {
              tooltip: {
                callbacks: {
                  label: function (context) {
                    let label = context.dataset.label || '';

                    if (label) {
                      let value = context.dataset.data[context.dataIndex];
                      label += ': ' + value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
                    }
                    return label;
                  }
                }
              }
            }
          }
        }
      );
    }

  }


  async loadData() {
    try {
      const yearNow = new Date().getFullYear();
      const formattedStartDate = `${yearNow - 6}-01-01`;
      const formattedEndDate = `${yearNow}-12-31`;
      this.iOrdAge = await this.docService.fetchOrdAge("", this.COD_AGE, this.COD_AGE, formattedStartDate, formattedEndDate);
      this.processDataPie();
      this.processDataBar();

      this.loaded = true;

    } catch (error) {
      console.error('Error:', error);
    }
  }

  processDataPie() {
    const distinctYears = [...new Set(this.iOrdAge.documenti.map(doc => doc.ANNO_DOC))];
    const data = distinctYears.map(year => this.calculateSum(year));

    this.dataPie.labels = distinctYears;
    this.dataPie.datasets[0].data = data;
    this.dataPie.datasets[0].backgroundColor = ['#36A2EB', '#FF6384', '#FFCD56', '#FF9F40', '#4BC0C0', '#C9CBCF']

  }


  processDataBar() {
    const distinctYears = [...new Set(this.iOrdAge.documenti.map(doc => doc.ANNO_DOC))];
    const top6Data = this.findTop5Data(distinctYears);

    const backgroundColor = [
      'rgb(255, 99, 132)',
      'rgb(255, 159, 64)',
      'rgb(255, 205, 86)',
      'rgb(75, 192, 192)',
      'rgb(54, 162, 235)',
      'rgb(153, 102, 255)',
      'rgb(201, 203, 207)'
    ]

    this.dataBar.labels = distinctYears;
    this.dataBar.datasets = top6Data.map((dataItem, index) => ({
      data: distinctYears.map(year => this.calculateSum(year, dataItem.COD_CF)),
      label: dataItem.RAG_SOC_CF,
      backgroundColor: backgroundColor[index],
    }));
  };


  findTop5Data(distinctYears: string[]): { RAG_SOC_CF: string, COD_CF: string, sum: number }[] {
    return this.iOrdAge.documenti
      .reduce((acc, doc) => {
        const existingItem = acc.find(item => item.COD_CF === doc.COD_CF);
        if (existingItem) {
          existingItem.sum += doc.IMPONIBILE_V1 || 0;
        } else {
          acc.push({
            RAG_SOC_CF: doc.RAG_SOC_CF,
            COD_CF: doc.COD_CF,
            sum: doc.IMPONIBILE_V1 || 0,
          });
        }
        return acc;
      }, [] as { RAG_SOC_CF: string, COD_CF: string, sum: number }[])
      .sort((a, b) => b.sum - a.sum)
      .slice(0, 5);
  }


  calculateSum(year: string, COD_CF?: string): number {
    return this.iOrdAge.documenti
      .filter(doc => doc.ANNO_DOC === year && (!COD_CF || doc.COD_CF === COD_CF))
      .reduce((sum, doc) => sum + (doc.IMPONIBILE_V1 || 0), 0);
  }

  destroyCharts() {
    if (this.chartCli) {
      this.chartCli.destroy();
    }
    if (this.chartVen) {
      this.chartVen.destroy();
    }

    // Clear the canvas elements
    var canvasCli = this.canvasCli.nativeElement;
    var canvasVen = this.canvasVen.nativeElement;

    var contextCli = canvasCli.getContext('2d');
    var contextVen = canvasVen.getContext('2d');

    contextCli.clearRect(0, 0, canvasCli.width, canvasCli.height);
    contextVen.clearRect(0, 0, canvasVen.width, canvasVen.height);
  }
}
